import React from 'react'
import qualityWarningStyles from './QualityWarning.module.scss'
import Icon, { IconType } from '@bt-react/components/Icon'

interface QualityWarningProps {
    onCloseClick?: () => void
    text: string
}

const QualityWarning = (props: QualityWarningProps) => {

    const { onCloseClick, text } = props

    return <div className={qualityWarningStyles['quality-warning']}>
        <div className={qualityWarningStyles['text']}><Icon name={ IconType.iconName.dangerCircle } colour={IconType.colour.tertiary} className={ qualityWarningStyles['danger-icon'] }/><b>Poor video quality!</b><span>{text}</span></div>
        <div onClick={onCloseClick} className={qualityWarningStyles['close']}>
            <Icon name={ IconType.iconName.close } colour={IconType.colour.task} className={ qualityWarningStyles['close-icon'] }/>
        </div>
    </div>
}

export default QualityWarning